module.exports = __webpack_public_path__ + "img/4.d43744ad.jpg";